import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { ShipFromQuery } from "view/ships/ShipDetails";
import { LocationLink, RelationLink } from "utils/LinkUtils";
import { ChildProps } from "types/commons";

const ShipAgentsTable = ({ agents }: { agents: ChildProps<ShipFromQuery, "agents">  }) => {
	return (
		<Table
			id="ship-agents"
			content={agents.map(it => ({ ...it, id: undefined }))}
			columns={[ {
				id: "location",
				title: intl.formatMessage({ id: "LOCATION" }),
				render: (row) => <LocationLink location={row.location} />,
			}, {
				id: "agent",
				title: intl.formatMessage({ id: "AGENCY" }),
				render: row => <RelationLink relation={row.agent} />,
			} ]}
			disableFooter />
	);
};

export default ShipAgentsTable;
